import React, { createContext, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { _checkComponentTimes, _showStates } from '../../../App';
import MotionWait from '../../motions/MotionWait';
import { startHandlers, startInitialState, startReducer, startTypes } from '../reducers/StartReducer';
import useTimeMeasurement from '../reducers/reducerHelpers/validTimer';
import { useRenders } from './useHelpers/useRenders';

const killInterval = 0.5

/** Displays a `PageDimmer` until the `handleAmmend_startDimmer` function in called */
export const StartContext = createContext();

const StartProvider = (props) => {

  const init_state = { startType: startTypes.app, startTime: Date.now(), killInterval }
  const [start_state, start_dispatch] = useReducer(startReducer, init_state, startInitialState)
  const { killDimmer } = start_state ?? {}

  const start_handlers = useMemo(
    () => startHandlers(start_dispatch),
    [start_dispatch]
  );

  if (_showStates.any && _showStates.start) {
    console.log('--- start ---')
    console.log(Object.keys(start_state))
    console.log(Object.keys(start_handlers))
  }

  const [componentTimes, setComponentTimes] = useState({})

  useRenders('Start Provider', true)

  const start_fns = {
    useTimeMeasurement: (typeOf, valid) => {
      const cb = (x) => {
        const _componentTimes = { ...componentTimes }
        _componentTimes[typeOf] = x
        setComponentTimes(_componentTimes)
      }
      useTimeMeasurement(typeOf, valid, cb)
    },
  }

  _checkComponentTimes && start_fns.useTimeMeasurement('StartProvider', killDimmer)

  useEffect(() => {
    if (_showStates.any && _showStates.start) {
      if (_checkComponentTimes && componentTimes) {
        console.log('componentTimes', componentTimes)
      }
    }
    // eslint-disable-next-line
  }, [componentTimes]);

  // return <div>StartContext</div>

  return <StartContext.Provider value={{ start_state, start_handlers, start_fns }}>
    <MotionWait origin={'StartProvider'} />
    {props.children}
  </StartContext.Provider>
}

export default StartProvider 